import { propertyTypesQueryKeys as e } from "./usePropertyTypesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertyTypesApi as n } from "@maat/api-main";
//#region src/propertyTypes/usePropertyTypes.ts
var r = (r) => t({
	queryKey: e.list(r),
	queryFn: () => n.getPropertyTypes(r)
});
//#endregion
export { r as usePropertyTypes };
